module.exports = __webpack_public_path__ + "img/donguri@2x1.5efb72d3.png";